module.exports = __webpack_public_path__ + "img/lb_menu_bg.a27a9f8d.png";